
import React, { useRef, useEffect, useState } from "react";

import './styles.css'

const miselect={
    /*fontSize: "14pt",*/
    /*lineHeight: "1.5",*/
    border: "1px solid #ced4da",
    borderRadius: ".25rem",
    display: "block",
    width: "100%",
    padding: ".275rem .75rem", 
}

const NuCheckbox = ({ id, label, checked,value, onChange, ...props }) => {
    // 
    const defaultChecked = checked ? checked : false;
    //const [isChecked, setIsChecked] = useState(defaultChecked);
    //const [isChecked, setIsChecked] = useState(defaultChecked);
    //
    return (
      <div className="checkbox-wrapper">
        {
          //JSON.stringify(value)
        }
        <input
          id={id}
          type="checkbox"
          //checked={isChecked}
          checked={ value===1? true:false }
          //onChange={() => setIsChecked((prev) => !prev)}
          onChange={onChange} 
          {...props}
        />
        <label htmlFor={id}>{label}</label>
      </div>
    );
  }
  
  export default NuCheckbox;


  /*<NuCheckbox
      label=""
      name="chk_e1"
      value={this.state.form.chk_e1}
      onChange={ this.handleChangeForm }
    />*/